import { Crown } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-[#2A2626] text-[#F9F6F0] py-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <Crown className="w-10 h-10 text-[#A85A43]" strokeWidth={1.5} />
              <h3 className="text-3xl font-[Playfair_Display] italic tracking-tight">
                Protect Your Crown
              </h3>
            </div>
            <p className="text-[#F9F6F0]/80 leading-relaxed">
              Handcrafted crocheted hats made with love and care.
            </p>
            <p className="text-[#F9F6F0]/60 mt-4 text-sm">
              Established 2023 by Christian Clark
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-[Playfair_Display] mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#F9F6F0]/80 hover:text-[#A85A43] transition-colors" data-testid="footer-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-[#F9F6F0]/80 hover:text-[#A85A43] transition-colors" data-testid="footer-products">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#F9F6F0]/80 hover:text-[#A85A43] transition-colors" data-testid="footer-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#F9F6F0]/80 hover:text-[#A85A43] transition-colors" data-testid="footer-faq">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-[#F9F6F0]/80 hover:text-[#A85A43] transition-colors" data-testid="footer-blog">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#F9F6F0]/80 hover:text-[#A85A43] transition-colors" data-testid="footer-contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-[Playfair_Display] mb-4">Get in Touch</h4>
            <p className="text-[#F9F6F0]/80 leading-relaxed">
              Email: <a href="mailto:info@protectmycrown.com" className="hover:text-[#A85A43] transition-colors" data-testid="footer-email">
                info@protectmycrown.com
              </a>
            </p>
          </div>
        </div>
        
        <div className="mt-16 pt-8 border-t border-[#F9F6F0]/20 text-center">
          <p className="text-[#F9F6F0]/60 text-sm">
            © 2023 Protect Your Crown. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
